import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PermissionModel } from 'src/app/models/api/permission.model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PermissionsEnum } from 'src/app/constants/settings.enum';
import { PermissionsService } from '../../permissions.service';
import { LevelEnum } from 'src/app/constants/level.enum';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ForcePermissionModal, ForcePermissionModalOptions } from 'src/app/components/settings/modals/force-permission/force-permission.modal';
@Component({
  selector: 'app-configure-permission',
  templateUrl: './configure-permission.component.html'
})
export class ConfigurePermissionComponent implements OnInit, OnDestroy {
  @Input() forPermission!: PermissionsEnum | string;
  private _level!: LevelEnum;
  showForce: boolean = false;
  @Input() set level(level: LevelEnum) {
    this._level = level;
    this.showForce = level !== LevelEnum.OrganisationLevel;
  }
  get level(): LevelEnum {
    return this._level;
  }
  permission: PermissionModel = new PermissionModel();
  showVisible: boolean = false;
  showLock: boolean = false;
  showDisabled: boolean = false;
  isSystemAdmin: boolean = false;
  isWLAdmin: boolean = false;
  get hide(): boolean {
    // its hidden
    // i am not an WL/System Admin 
    // or its hidden AND disabled than you must be SystemAdmin
    return this.permission.isHidden && ((!this.isWLAdmin && !this.isSystemAdmin) && (this.permission.isDisabled || this.isSystemAdmin));
  }
  authenticationServiceSubscription: Subscription;
  permissionsUpdatedSubscription: Subscription;
  constructor(private authenticationService: AuthenticationService,
    private permissionsService: PermissionsService, protected modalService: NgbModal) {
    this.authenticationServiceSubscription = this.authenticationService.currentUser.subscribe((data) => {
      this.isSystemAdmin = data.isSystemAdmin;
      this.isWLAdmin = data.isWhitelabelAdmin;
      this.showLock = (data.isSystemAdmin || data.isWhitelabelAdmin);
      this.showVisible = (data.isSystemAdmin || data.isWhitelabelAdmin);
      this.showDisabled = (data.isSystemAdmin);
      this.showForce = this.level === LevelEnum.WhitelabelLevel || this.level === LevelEnum.SystemLevel;
    });

    this.permissionsUpdatedSubscription = this.permissionsService.permissionsUpdated.subscribe(unneededValue => {
      this.getPermission();
    });
  }
  ngOnInit(): void {
    this.getPermission();
  }
  ngOnDestroy() {
    if (this.authenticationServiceSubscription) {
      this.authenticationServiceSubscription.unsubscribe();
    }
    if (this.permissionsUpdatedSubscription) {
      this.permissionsUpdatedSubscription.unsubscribe();
    }
  }

  private getPermission() {
    this.permission = this.permissionsService.GetPermission(this.forPermission);
  }

  updatePermissionLockConfig(event: any) {
    let permissionElement: HTMLInputElement = (event.target as HTMLInputElement);
    this.permission.isLocked = permissionElement.checked;
    this.permissionsService.UpdatePermissionConfiguration(this.forPermission, this.level, null, null, this.permission.isLocked);
  }

  updatePermissionVisibleConfig(event: any) {
    let permissionElement: HTMLInputElement = (event.target as HTMLInputElement);
    this.permission.isHidden = permissionElement.checked;
    this.permissionsService.UpdatePermissionConfiguration(this.forPermission, this.level, null, this.permission.isHidden, null);
  }

  updatePermissionDisableConfig(event: any) {
    let permissionElement: HTMLInputElement = (event.target as HTMLInputElement);
    this.permission.isDisabled = permissionElement.checked;
    this.permissionsService.UpdatePermissionConfiguration(this.forPermission, this.level, this.permission.isDisabled, null, null);
  }

  openForceModal() {
    if (this.modalService.hasOpenModals()) {
      return;
    }
    let forcePermissionModalRef = this.modalService.open(ForcePermissionModal, ForcePermissionModalOptions);
    (forcePermissionModalRef.componentInstance as ForcePermissionModal).forPermission = this.forPermission;
    (forcePermissionModalRef.componentInstance as ForcePermissionModal).level = this.level;
    (forcePermissionModalRef.componentInstance as ForcePermissionModal).forcePermissionAction.subscribe(async () => {
        this.permissionsService.ForcePermissionValueAndConfiguration(this.forPermission, this.level);
    });
  }
}